import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Confirm } from "../../components/confirm";
import { deleteProperty } from "../../services/property";
import { useLocale } from "../../stores/locale";
import { navigateBack } from "../../utils/navigate-back";

export function MaintenancePropertyDelete() {
  const navigate = useNavigate();
  const { get: getLocale } = useLocale();
  const queryClient = useQueryClient();
  const { id } = useParams();

  if (!id) {
    throw new Error("Property ID is required");
  }

  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const closeModal = () => {
    navigateBack(navigate, "/admin/maintenance/property");
  };

  return (
    <Confirm
      header={
        hasError
          ? getLocale("maintenance.propertyDeleteError")
          : getLocale("property.confirmDelete")
      }
      loading={loading}
      onClose={closeModal}
      onConfirm={() => {
        void (async () => {
          setLoading(true);
          setHasError(false);
          try {
            await deleteProperty(id);
            await queryClient.invalidateQueries({ queryKey: ["properties"] });
            closeModal();
          } catch {
            setHasError(true);
          } finally {
            setLoading(false);
          }
        })();
      }}
    />
  );
}
